<template>
  <div class="contents">
      <h2>会社連絡</h2>

      <div class="container">
          <template v-if="isLoading">
              <template v-if="!isError">
                <loading :message="'データ読み込み中...'"></loading>
              </template>
          </template>
          <template v-else>
              <div class="baseinfo">

              </div><!-- /baseinfo -->

              <div class="maininfo">

                <!-- 会社連絡表示 -->
                <template v-if="oshiraseId && type">
                  <renrakuDeatail :oshiraseId="oshiraseId" :dataType="type"/>
                </template>
                <template v-else>
                  <renrakuDeatailList  :isLoading="isLoading" :isError="isError" :dataList="form" />
                </template>

              </div><!-- /maininfo -->
          </template>
      </div>


  </div>
</template>

<script lang="ts">

import { Ref, defineComponent, onMounted, ref } from 'vue';
import RenrakuDetailList from "@/components/renraku/detail/parts/DetailList.vue";
import RenrakuDetail from "@/components/renraku/detail/parts/Detail.vue";
import { useInit } from '@/composable/renraku/detail/init';
import { RouterConst } from '@/const/Router';
import OptionConst from "@/const/Option";
import { useRoute } from "vue-router";

export default defineComponent({
  setup() {

    const route = useRoute()
    const oshiraseId: Ref<number | null> = ref(null);
    const type: Ref<string | null> = ref(null);

    onMounted(() => {
      oshiraseId.value = route.params.oshiraseId ? parseInt(route.params.oshiraseId as string, 10) : null
      type.value = route.params.type ? route.params.type as string : null
    })

    // 初期化
    const { isLoading, isError, form } = useInit();

    return {
      isLoading,
      isError,
      form,
      RouterConst,
      OptionConst,
      oshiraseId,
      type,
    }
  },
  components: {
    renrakuDeatailList: RenrakuDetailList,
    renrakuDeatail: RenrakuDetail,
  }
})
</script>
